export interface ContactSection {
    title: string;
    content?: any;
}

export interface ContactContentSection {
    general: ContactSection;
    injury: ContactSection;
    vehicleDamage: ContactSection;
    others?: any;
}

export interface AdjusterSummaries {
    adjusterSummaries: Array<AdjusterRoleExposure>;
    loadTime: any;
}

export interface AdjusterRoleExposure {
    adjuster: Adjuster;
    role: string;
    exposureType?: string;
}

export interface Adjuster {
    publicID: string;
    displayName: string;
    firstName: string;
    lastName: string;
    phoneNumber: string;
    phoneFax: string;
    email: string;
}

export interface Incident {
    publicID: string;
    subtype: string;
    incidentOwner?: any;
    lossParty?: string;
}

export interface VendorDetails {
    trade: string;
    referralProgram: string;
    isCancelled: boolean;
}

export interface VendorContactDetails {
    companyName: string;
    phoneNumber: string;
    addressLine1?: string;
    addressLine2?: string;
    city?: string;
    state?: string;
    zip?: string;
    contactPublicId?: string;
}

export interface Vendor {
    vendorDetailsDTO: VendorDetails;
    vendorContactDetailsDTO: VendorContactDetails;
}

export interface ServiceOffering {
    publicID: string;
    type: string;
    serviceSelected?: string;
    serviceSelectedDate?: string;
    isEligible: boolean;
    vendors?: Vendor[];
}

export interface ContractorDisplay {
    trade: string;
    companyName: string;
    phoneNumber: string;
    address?: string;
}

// eslint-disable-next-line no-shadow
export enum ContractorState {
    LOADING = 'LOADING',
    HAS_CONTRACTORS = 'HAS_CONTRACTORS',
    NO_OFFERINGS = 'NO_OFFERINGS',
    ERROR = 'ERROR'
}
// eslint-disable-next-line no-shadow
export enum PaymentState {
    LOADING = 'LOADING',
    HAS_PAYMENTS = 'HAS_PAYMENTS',
    NO_PAYMENTS = 'NO_PAYMENTS',
    ERROR = 'ERROR'
}
// eslint-disable-next-line no-shadow
export enum PaymentAccount {
    NO_BANK_ACCOUNT = 'NO_BANK_ACCOUNT',
    HAS_BANK_ACCOUNT = 'HAS_BANK_ACCOUNT',
    LOADING = 'LOADING',
    ERROR = 'ERROR'
}
export interface ClaimEvent {
    eventName: string;
    eventType: string;
    eventDate: string;
    eventDescription: string;
}

export interface ClaimEventsResponse {
    claimEvents: ClaimEvent[];
    loadTime?: number;
}

export interface ClaimEventDisplay {
    iconName: string;
    iconColor: string;
    eventName: string;
    description: string;
    eventDate: Date;
}

// eslint-disable-next-line no-shadow
export enum ClaimUpdatesState {
    LOADING = 'LOADING',
    HAS_UPDATES = 'HAS_UPDATES',
    NO_UPDATES = 'NO_UPDATES',
    ERROR = 'ERROR'
}

// Support Section Interfaces
export interface AdjusterDisplay {
    displayName: string;
    phoneNumber: string;
    email: string;
    role: string;
}

export interface AgentDisplay {
    displayName: string;
    phoneNumber: string;
    email: string;
}

export interface PolicySummary {
    publicID: string;
    policyNumber: string;
    policyType: string;
    status: string;
    nw_RateState?: string;
}

export interface Policy {
    publicID: string;
    policyNumber: string;
    nw_RateState: string;
    agent?: {
        displayName: string;
        workNumber?: string;
        primaryAddress?: {
            emailAddress1?: string;
        };
    };
}

export interface FraudLanguage {
    state: string;
    language: string;
    font?: string;
    size?: number;
}

export interface FraudLanguageResponse {
    FraudLanguage: FraudLanguage;
}

export interface FAQ {
    question: string;
    answer: string;
}

// eslint-disable-next-line no-shadow
export enum SupportState {
    LOADING = 'LOADING',
    HAS_DATA = 'HAS_DATA',
    ERROR = 'ERROR'
}

// eslint-disable-next-line no-shadow
export enum DocumentsState {
    LOADING = 'LOADING',
    HAS_DOCUMENTS = 'HAS_DOCUMENTS',
    NO_DOCUMENTS = 'NO_DOCUMENTS',
    ERROR = 'ERROR'
}
